import {AfterViewInit, Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {SettingService} from '../../../../../services/setting.service';
import { IntakeAccess, IntakeAccessService } from '../../../intake-access.service';
import { SampleInspection } from '../../../../../extras/sample-inspection.interceptor';

@Component({
  selector: 'app-intake-header',
  templateUrl: './intake-header.component.html',
  styleUrls: ['./intake-header.component.scss']
})
export class IntakeHeaderComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() jobId: string;
  @Input() location: string;
  @Input() tab: boolean;
  @Input() rounded: boolean;
  // 'home': the termite inspection tabs are hidden (Home / Termite Inspection selector);
  // null while the job is loading.
  @Input() service: string = null;

  // The tabs show once everything that decides them has loaded (tab order and access, and on a
  // job its Home / Termite service), so they appear once instead of shifting as each arrives.
  private tabsLoaded = false;
  get ready(): boolean {
    return this.tabsLoaded && (!this.jobId || this.service !== null);
  }

  inspector: boolean;
  // Which tab groups this user may open (null until known).
  access: IntakeAccess = null;

  tabs_order = [];
  tab_links = {
    'client': 'inspections-order-parties',
    'property': 'inspections-edit-property',
    'scheduling': 'inspections-schedule',
  };
  tab_labels = {
    'client': 'Client',
    'property': 'Property',
    'scheduling': 'Scheduling',
  };

  constructor(private settingService: SettingService, private intakeAccess: IntakeAccessService,
              private el: ElementRef) {
  }

  ngOnInit() {
    const userData = JSON.parse(localStorage.getItem('user'));
    if (userData.user_level === 'inspector') {
      this.inspector = false;
      this.tab = true;
    } else {
      this.inspector = true;
      // Every tab shows once the job exists (mockup; the +/- toggle was removed 2026-10-13).
      this.tab = !!this.jobId;
    }
    this.intakeAccess.access().subscribe(access => {
      this.access = access;
      this.settingService.getSettingData().subscribe(
        data => {
          const tabOrders = {};
          for (const tab of data.tabs_order) {
            if (access.intake) {
              this.tabs_order.push(tab);
              tabOrders[tab] = this.tab_links[tab];
            }
          }
          localStorage.setItem('tab_orders', JSON.stringify(tabOrders));
          this.tabsLoaded = true;
          this.revealActiveTab();
        }
      );
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.location && !changes.location.firstChange) || changes.service) {
      this.revealActiveTab();
    }
  }

  ngAfterViewInit() {
    this.revealActiveTab();
  }

  // The tabs scroll sideways: bring the current one into view (horizontally only), once the
  // tabs that load with the access / settings data have rendered.
  private revealActiveTab() {
    setTimeout(() => {
      const scroller: HTMLElement = this.el.nativeElement.querySelector('.im-workflow-scroll');
      const active: HTMLElement = scroller && scroller.querySelector('.im-workflow-item.active');
      if (active) {
        const box = scroller.getBoundingClientRect();
        const tab = active.getBoundingClientRect();
        scroller.scrollLeft += tab.left - box.left - (box.width - tab.width) / 2;
      }
    });
  }

  get isSample(): boolean {
    return this.jobId === SampleInspection.JOB_ID;
  }

  // A change refused on the sample: the banner says so for a few seconds (some pages show nothing).
  sampleBlocked = false;
  private sampleBlockedTimer: any;

  @HostListener('window:im-sample-blocked')   // SampleInspection.BLOCKED_EVENT
  onSampleBlocked() {
    this.sampleBlocked = true;
    clearTimeout(this.sampleBlockedTimer);
    this.sampleBlockedTimer = setTimeout(() => this.sampleBlocked = false, 5000);
  }

}
